module.exports = __webpack_public_path__ + "img/catering_menu_3.dbb88bf3.jpg";